import { render, staticRenderFns } from "./NewsSidebar.vue?vue&type=template&id=2b931f6a"
import script from "./NewsSidebar.vue?vue&type=script&lang=js"
export * from "./NewsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports